import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import { Botao, Cartao, classesBotao } from '../../../web/src/componentes/base';
import { useToast } from '../../../web/src/componentes/toast';
import { mensagemDeErro } from '../../../web/src/nucleo/api';
import { baixar } from '../api';
import { nomeEmpresa, useSessao } from '../sessao';
import { dataCurta } from './comum';

/**
 * Trajetórias (19/10, item 5): a tela inicial do MODO SAÍDA (último contrato encerrado). Até a data, o cliente consulta os
 * documentos e o histórico financeiro e baixa os dados para levar a outro escritório; cobranças novas e o chat somem.
 */
export function Saida() {
  const { t, i18n } = useTranslation('portal');
  const s = useSessao();
  const toast = useToast();
  const idioma = i18n.language.slice(0, 2);
  const ate = s.saida?.ate ?? null;
  const baixarDados = async () => {
    try {
      await baixar('/saida/pacote', 'meus-dados-escritorio.json');
      toast.sucesso(t('saida.baixado'));
    } catch (e) {
      toast.erro(mensagemDeErro(e));
    }
  };
  return (
    <div className="flex flex-col gap-4" data-saida>
      <div>
        <p className="kicker break-words">{nomeEmpresa(s)}</p>
        <h1 className="mt-1 text-2xl font-bold tracking-tight break-words">{t('saida.titulo')}</h1>
      </div>
      <Cartao>
        <div className="flex flex-col gap-3">
          <p className="text-sm text-tinta-1">{t('saida.texto', { data: dataCurta(ate, idioma) })}</p>
          <p className="text-sm text-tinta-3">{t('saida.depois')}</p>
          <div className="flex flex-col gap-2 border-t border-borda pt-3">
            <p className="text-sm text-tinta-2">{t('saida.baixarTexto')}</p>
            <div>
              <Botao variante="primario" icone={<Download className="size-4" aria-hidden />} onClick={() => void baixarDados()}>
                {t('saida.baixar')}
              </Botao>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 border-t border-borda pt-3">
            <Link to="/documentos" className={classesBotao('secundario', 'sm')}>
              {t('saida.documentos')}
            </Link>
            {s.secoes.financeiro && (
              <Link to="/financeiro" className={classesBotao('secundario', 'sm')}>
                {t('saida.financeiro')}
              </Link>
            )}
          </div>
        </div>
      </Cartao>
    </div>
  );
}
